import { useEffect, useRef, useState } from "react";
import { string, array, oneOf } from "prop-types";
import Button from "../Button/Button.jsx";
import Modal from "../../../../Common/js/components/Modal/Modal.jsx";
import renderModalLink from "./renderModalLink.jsx";

const propTypes = {
  classes: array,
  id: string, // not currently used, but might need this in the future.  To put in the url, for example
  modalContent: string.isRequired,
  text: string.isRequired,
  type: oneOf(["link", "button"]),
};

const ModalLink = (props) => {
  const { classes, modalContent, text, type } = props;

  const [isOpen, toggleOpen] = useState(false);

  const contentRef = useRef();

  useEffect(() => {
    if (contentRef.current) {
      // render any nested modals
      renderModalLink(contentRef.current);
    }
  }, []);

  return (
    <div className="modal-link">
      <Button
        className={classes.join(" ")}
        as={type === "link" ? "a" : undefined}
        onClick={() => {
          toggleOpen(true);
        }}
      >
        {text}
      </Button>
      {modalContent && (
        <Modal
          className="modal--from-button"
          noPadding
          isOpen={isOpen}
          onClose={() => {
            toggleOpen(false);
          }}
          title={false}
        >
          <div
            ref={contentRef}
            dangerouslySetInnerHTML={{ __html: modalContent }}
          />
        </Modal>
      )}
    </div>
  );
};

ModalLink.propTypes = propTypes;
export default ModalLink;
